import Article from './Article.store';
import Notification from './Notification.store';
import Period from './Period.store';
import Popup from './Popup.store';
import Room from './Room.store';
import User from './User.store';

const modules = { Article, Notification, Period, Popup, Room, User };

export default modules;
